import _ from 'lodash'

const remark = (data) => {
	const remarks = data.map(
		({
			id,
			title: { rendered: title },
			content: { rendered: content },
			_embedded: embedded,
			acf: { titre: agencyName },
		}) => {
			const regx = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g
			const regSrcset = /srcset\s*=\s*['"]([^'"]+)['"]/g

			const images = content.match(regSrcset)
			const imageToRemove = content.match(regx)

			const urlImage = !_.isEmpty(images) && images[0].match(images)
			const urlsBySize = (!_.isEmpty(urlImage) && urlImage[0].split('"'))[1] || null

			const srcset = (!_.isEmpty(urlsBySize) && urlsBySize.split(' ')[0]) || null

			const featuredmedia =
				embedded && embedded['wp:featuredmedia'] && embedded['wp:featuredmedia'][0]

			const url = featuredmedia?.media_details?.sizes?.full?.source_url
			const caption = featuredmedia?.caption?.rendered

			return {
				caption,
				artistName: title,
				agencyName,
				content: _.replace(content, imageToRemove, ''),
				image: (!_.isEmpty(images) && images[0]) || null,
				url,
				srcset,
			}
		},
	)

	return remarks
}

export default remark
